import { render, staticRenderFns } from "./FaviconSpecifications.vue?vue&type=template&id=e3777f96&"
import script from "./FaviconSpecifications.vue?vue&type=script&lang=js&"
export * from "./FaviconSpecifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports